var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHubicon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.6667H14.6667V4H4V14.6667ZM6.66667 6.66667H12V12H6.66667V6.66667Z",
    fill: "#2D2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H14.6667V17.3333H4V28ZM6.66667 20H12V25.3333H6.66667V20Z",
    fill: "#2D2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.332 28H27.9987V17.3334H17.332V28ZM19.9987 20H25.332V25.3334H19.9987V20Z",
    fill: "#2D2E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9987 8V4H21.332V8H17.332V10.6667H21.332V14.6667H23.9987V10.6667H27.9987V8H23.9987Z",
    fill: "#2D2E2E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubicon4);
export default __webpack_public_path__ + "static/media/hubicon4.681c87288f94548a06f67ed78bdb2780.svg";
export { ForwardRef as ReactComponent };